import React from 'react';

const NetdiskCapacityInfo: React.FC = () => {
    return (
        <div>
            <h2 className="text-[18px] text-[#090909] font-bold ml-[2px]">百度网盘资源不占奇鹿空间</h2>
            <p className="mt-[7px] text-[12px] leading-[1.6] text-[#7B7F88]">
                源文件继续保存在你的百度网盘，奇鹿只保存作品关系和制作效果，不重复占用奇鹿空间。
            </p>
            <div className="mt-[12px] grid gap-[8px]">
                <div className="flex items-start rounded-[11px] bg-[#EEF9F2] px-[11px] py-[10px]">
                    <span className="mr-[8px] text-[#4EA36A]">✓</span>
                    <span className="text-[12px] leading-[1.55] text-[#385F45]">从自己的百度网盘制作，奇鹿空间占用 0 B</span>
                </div>
                <div className="flex items-start rounded-[11px] bg-[#F0F5FF] px-[11px] py-[10px]">
                    <span className="mr-[8px] text-[#6482CF]">✓</span>
                    <span className="text-[12px] leading-[1.55] text-[#435475]">导入好友作品并使用自己网盘中的文件，奇鹿空间占用 0 B</span>
                </div>
            </div>
            <p className="mt-[10px] text-[10px] leading-[1.6] text-[#A0A3AA]">
                直接上传到奇鹿的本地文件按实际大小计费；转存奇鹿站内资源按原资源大小的 10% 计费。
            </p>
        </div>
    );
};

export default NetdiskCapacityInfo;
